// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArchivosEvolucionesMedicasController from "./archivos_evoluciones_medicas_controller.js"
application.register("archivos-evoluciones-medicas", ArchivosEvolucionesMedicasController)

import BsModalController from "./bs_modal_controller.js"
application.register("bs-modal", BsModalController)

import BuscarReportesController from "./buscar_reportes_controller.js"
application.register("buscar-reportes", BuscarReportesController)

import DatepickerController from "./datepicker_controller.js"
application.register("datepicker", DatepickerController)

import DatetimepickerController from "./datetimepicker_controller.js"
application.register("datetimepicker", DatetimepickerController)

import DrogasVasoactivasController from "./drogas_vasoactivas_controller.js"
application.register("drogas-vasoactivas", DrogasVasoactivasController)

import DropzoneController from "./dropzone_controller.js"
application.register("dropzone", DropzoneController)

import EpicrisisArmController from "./epicrisis_arm_controller.js"
application.register("epicrisis-arm", EpicrisisArmController)

import FilterConsumosFarmaciasController from "./filter_consumos_farmacias_controller.js"
application.register("filter-consumos-farmacias", FilterConsumosFarmaciasController)

import FilterIndicacionesMedicasController from "./filter_indicaciones_medicas_controller.js"
application.register("filter-indicaciones-medicas", FilterIndicacionesMedicasController)

import IndicacionesMedicasController from "./indicaciones_medicas_controller.js"
application.register("indicaciones-medicas", IndicacionesMedicasController)

import IndicacionesMedicasOfficeController from "./indicaciones_medicas_office_controller.js"
application.register("indicaciones-medicas-office", IndicacionesMedicasOfficeController)

import IndicacionesMedicasOfficePickerController from "./indicaciones_medicas_office_picker_controller.js"
application.register("indicaciones-medicas-office-picker", IndicacionesMedicasOfficePickerController)

import InplaceController from "./inplace_controller.js"
application.register("inplace", InplaceController)

import MasterPasswordAuditoresController from "./master_password_auditores_controller.js"
application.register("master-password-auditores", MasterPasswordAuditoresController)

import ModalsController from "./modals_controller.js"
application.register("modals", ModalsController)

import NotificationsController from "./notifications_controller.js"
application.register("notifications", NotificationsController)

import ProtocoloModeloLinkerController from "./protocolo_modelo_linker_controller.js"
application.register("protocolo-modelo-linker", ProtocoloModeloLinkerController)

import RespiratorioArmController from "./respiratorio_arm_controller.js"
application.register("respiratorio-arm", RespiratorioArmController)

import SalvedadController from "./salvedad_controller.js"
application.register("salvedad", SalvedadController)

import SearchPacientesController from "./search_pacientes_controller.js"
application.register("search-pacientes", SearchPacientesController)

import SpeechController from "./speech_controller.js"
application.register("speech", SpeechController)

import TagifyController from "./tagify_controller.js"
application.register("tagify", TagifyController)

import TimepickerController from "./timepicker_controller.js"
application.register("timepicker", TimepickerController)

import ToastrController from "./toastr_controller.js"
application.register("toastr", ToastrController)

import ToggleCarpetaRevisadaController from "./toggle_carpeta_revisada_controller.js"
application.register("toggle-carpeta-revisada", ToggleCarpetaRevisadaController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import ToggleViasController from "./toggle_vias_controller.js"
application.register("toggle-vias", ToggleViasController)

import TomSelectController from "./tom_select_controller.js"
application.register("tom-select", TomSelectController)

import TurboController from "./turbo_controller.js"
application.register("turbo", TurboController)
